import { TextField, TextFieldProps } from '@mui/material';
import React from 'react';

type WIRFieldProps = Omit<TextFieldProps, 'size' | 'variant' | 'margin' | 'fullWidth'> & {
  children?: React.ReactNode;
  validateEmail?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const WIRField: React.FunctionComponent<WIRFieldProps> = ({
  children,
  validateEmail,
  onChange,
  ...textFieldProps
}) => {
  const [error, setError] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState('');
  const errorColor =
    errorMessage === 'Email entered contained redundant spaces. Updated!' ? '#3498db' : '#e74c3c';

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    let value = event.target.value;

    if (validateEmail && value.includes(' ')) {
      setError(true);
      setErrorMessage(`Email entered contained redundant spaces. Updated!`);
      value = value.replace(/\s+/g, '');
    } else {
      setError(false);
      setErrorMessage('');
    }

    if (onChange) {
      onChange({ ...event, target: { ...event.target, value } });
    }
  };

  const handleBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    const value =
      event.target.value && typeof event.target.value === 'string' ? event.target.value.trim() : '';

    if (value && validateEmail) {
      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailPattern.test(value)) {
        setError(true);
        setErrorMessage('Please enter a valid email address');
      } else {
        setError(false);
        setErrorMessage('');
      }
    } else if (!value && validateEmail) {
      setError(true);
      setErrorMessage('Please enter an email address');
    }
  };

  return (
    <TextField
      {...textFieldProps}
      variant="outlined"
      size="small"
      margin="dense"
      fullWidth
      onChange={handleChange}
      onBlur={handleBlur}
      error={error}
      helperText={errorMessage}
      sx={
        error
          ? {
              '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
                borderColor: errorColor,
              },
              '& .MuiFormLabel-root.Mui-error': { color: errorColor },
              '& .MuiFormHelperText-root.Mui-error': { color: errorColor },
              '& .MuiOutlinedInput-root.Mui-focused.Mui-error .MuiOutlinedInput-notchedOutline': {
                borderColor: errorColor,
              },
            }
          : undefined
      }
    >
      {children}
    </TextField>
  );
};

export default WIRField;
